import { useState } from 'react'
import Recetas from './Recetas'
import Menu from './Menu'
import Compras from './Compras'
import './Mealprep.css'

export default function Mealprep({
  menuRecetas, listaCompras, favoritos,
  onVerReceta, onRemoverDeMenu, onMarcarRealizada,
  onLimpiarCompras, onRemoverReceta
}) {
  const [subTab, setSubTab] = useState('recetas')

  return (
    <div className="mealprep-page">
      <div className="mealprep-subnav">
        <button
          className={`subnav-btn ${subTab === 'recetas' ? 'active' : ''}`}
          onClick={() => setSubTab('recetas')}
        >
          🍽 Catálogo
        </button>
        <button
          className={`subnav-btn ${subTab === 'menu' ? 'active' : ''}`}
          onClick={() => setSubTab('menu')}
        >
          📋 Mealprep
          {menuRecetas.length > 0 && <span className="subnav-badge">{menuRecetas.length}</span>}
        </button>
        <button
          className={`subnav-btn ${subTab === 'compras' ? 'active' : ''}`}
          onClick={() => setSubTab('compras')}
        >
          🛒 Compras
          {listaCompras.length > 0 && (
            <span className="subnav-badge">{new Set(listaCompras.map(i => i.origen)).size}</span>
          )}
        </button>
      </div>

      <div className="mealprep-contenido">
        {subTab === 'recetas' && (
          <Recetas onVerReceta={onVerReceta} favoritos={favoritos} />
        )}
        {subTab === 'menu' && (
          <Menu
            menuRecetas={menuRecetas}
            onVerReceta={onVerReceta}
            onRemoverDeMenu={onRemoverDeMenu}
            onMarcarRealizada={onMarcarRealizada}
          />
        )}
        {subTab === 'compras' && (
          <Compras
            lista={listaCompras}
            onLimpiar={onLimpiarCompras}
            onRemoverReceta={onRemoverReceta}
          />
        )}
      </div>
    </div>
  )
}
